import { BaseChangeLog } from '@models/next/ChangeLog';
import { z } from 'zod';

export const ArrivalNoticeLog = BaseChangeLog.extend({
  before_value: z.string(),
  after_value: z.string(),
  arrival_notice: z.number(),
});

export type ArrivalNoticeLog = z.infer<typeof ArrivalNoticeLog>;
